import React from "react";

const LandingPage = () => {
  return (
    <div className="w-[80vw] h-[90vh] font-serif italic text-purple-900 text-7xl h-screen flex flex-col justify-center items-center">
      <h1 className="">B.S. </h1>
      <h1 className="">Advertising</h1>
      <h1 className="">Company</h1>
    </div>
  );
};

export default LandingPage;
